export default __webpack_public_path__ + "static/media/logo-heal.23572638.png";